import cn from "classnames";
import { t } from "i18next";
import moment from "moment";

import { OrderUnpackingStatus } from "../../constants";
import { OrderUnpackingStatusLabelProps } from "./OrderUnpackingStatusLabel.types";

import styles from "./OrderUnpackingStatusLabel.module.scss";

const OrderUnpackingStatusLabel = ({
  unpackingStatus,
  quantityOfItemsToUnpack,
  unpackedAt
}: OrderUnpackingStatusLabelProps) => {
  switch (unpackingStatus) {
    case OrderUnpackingStatus.WaitingToReschedule:
      return (
        <div className={cn(styles.label, styles.label__orange)}>
          {t("Waiting to reschedule")}
        </div>
      );
    case OrderUnpackingStatus.WaitingToUnpack:
      return (
        <div className={cn(styles.label, styles.label__red)}>
          {`${quantityOfItemsToUnpack} ${Number(quantityOfItemsToUnpack) > 1 ? t("items") : t("item")} ${t("waiting to unpack")}`}
        </div>
      );
    case OrderUnpackingStatus.Unpacked:
      return (
        <div className={cn(styles.label, styles.label__green)}>
          {unpackedAt
            ? `${t("Unpacking completed")} ${moment(unpackedAt).format("DD/MM/YYYY")} ${t("at")} ${moment(unpackedAt).format("HH:mm")}`
            : t("Was not packaged")}
        </div>
      );

    default:
      return null;
  }
};

export default OrderUnpackingStatusLabel;
